import { INavList } from 'interfaces/navigation';

export const headerNavList: INavList[] = [
  { name: 'Home', url: '/' },
  { name: 'About Us', url: '/about' },
  { name: 'Our Apps', url: '/our-apps' },
  { name: 'Newsroom', url: 'https://newsroom.khatabook.com' },
  // { name: 'QR', url: '/qr' },
  { name: 'Join Us', url: '/hiring' },
  { name: 'Blog', url: '/blog' },
  { name: 'Contact Us', url: '/contact-us' }
];
